import { useGlobalStore } from "@/stores/GlobalStore";

export default function closeModals ({next}:any){
    const globalStore = useGlobalStore();

    globalStore.modal.contentObject = {};
    globalStore.modal.show = false;

    return next();
}